import { Grid, CircularProgress } from '@mui/material';

interface IGenericSpinnerProps {
  includeOverlay: boolean;
  overlayEntireModule?: boolean;
  fill?: string;
  padding?: number;
}

const GenericSpinner: React.FC<IGenericSpinnerProps> = (props) => {
  const padding = props.padding ? props.padding : 0;

  return (
    <div
      className={`${props.includeOverlay && 'overlayed-progress-circle'} ${
        props.overlayEntireModule && 'overlayed-progress-circle-outer-most'
      }`}
    >
      <Grid container direction="row" justifyContent="center">
        <div style={{ padding: `${padding}%` }}>
          <CircularProgress
            style={{ color: `${props.fill ? props.fill : ''}` }}
          />
        </div>
      </Grid>
    </div>
  );
};

export default GenericSpinner;
